import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { useTranslation } from "react-i18next";

const TooltipIndividualMetricsExplains: React.FC<any> = (props) => {
  const { style } = props;
  return (
    <Popover content={PopoverContent} placement="right" showArrow={false}>
      <InfoCircleOutlined style={style} />
    </Popover>
  );
};

const PopoverContent = () => {
  const { t } = useTranslation("radar");
  return (
    <div style={{ width: 700 }}>
      <div className="glossary-text">
        <h2 style={{ color: "#fff" }}>{t("pages.Radar.metrics")}</h2>
        <span style={{ display: "block", marginTop: 10 }}>
          <b>{t("pages.Radar.generalPerformance")} - </b>
          {t("pages.Radar.generalPerformanceExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 10 }}>
          <b>{t("pages.Radar.generalDevelopment")} - </b>
          {t("pages.Radar.generalDevelopmentExplaination")}
        </span>

        <span style={{ display: "block", marginTop: 10 }}>
          <b>{t("pages.Radar.generalEngagement")} - </b>
          {t("pages.Radar.generalEngagementExplanation")}
        </span>

        <span style={{ display: "block", marginTop: 10 }}>
          <b>{t("pages.Radar.generalFollowers")} - </b>
          {t("pages.Radar.generalFollowersExplanation")}
        </span>
      </div>
    </div>
  );
};

export default TooltipIndividualMetricsExplains;
